<p class="version-overlay">{{ version }}</p>
<router-outlet *ngIf="!chatModuleLoading"></router-outlet>
<loader [loading]="chatModuleLoading"></loader>
<app-overlay></app-overlay>
<app-customer-effort-support
  *ngIf="showCustomerEffortSupport() | async"
></app-customer-effort-support>
